import {Skeleton} from '@mui/material';
import Grid from '@mui/material/Grid2';

const AchievementTabsSkeleton = () => (
  <Grid
    size={12}
    container
    spacing={0}
    sx={{
      borderRadius: '12px',
      bgcolor: '#23242a',
      p: '0.5rem',
      height: '54px',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
    <Grid
      display={'flex'}
      alignItems={'center'}
      size={12}
      justifyContent={'space-between'}
      sx={{width: '100%'}}>
      <Skeleton
        variant="rectangular"
        width="230px"
        height="39px"
        sx={{
          clipPath: 'polygon(0 0, 100% 0, 90% 100%, 0 100%)',
          borderRadius: '12px 0 0 12px',
          bgcolor: '#1a1b20',
        }}
      />
      <Skeleton
        variant="rectangular"
        width="270px"
        height="39px"
        sx={{
          clipPath: 'polygon(10% 0, 90% 0, 100% 100%, 0 100%)',
          borderRadius: 0,
          bgcolor: '#1a1b20',
        }}
      />
      <Skeleton
        variant="rectangular"
        width="230px"
        height="39px"
        sx={{
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 12% 100%)',
          borderRadius: '0 12px 12px 0',
          bgcolor: '#1a1b20',
        }}
      />
    </Grid>
  </Grid>
);
export default AchievementTabsSkeleton;
